import { AppDispatch } from '..';
import { ModalActionTypes } from '../constants';

export const handleModal = (payload: boolean) => (dispatch: AppDispatch) => {
  dispatch({ type: ModalActionTypes.HANDLE_MODAL, payload });
};

export const handleModalRegister =
  (payload: boolean) => (dispatch: AppDispatch) => {
    dispatch({ type: ModalActionTypes.HANDLE_MODAL_REGISTER, payload });
  };

export const handleModalLogin =
  (payload: boolean) => (dispatch: AppDispatch) => {
    dispatch({ type: ModalActionTypes.HANDLE_MODAL_LOGIN, payload });
  };

export const handleModalCheckEmail =
  (payload: boolean) => (dispatch: AppDispatch) => {
    dispatch({ type: ModalActionTypes.HANDLE_MODAL_CHECK_EMAIL, payload });
  };

export const handleModalAccountVerified =
  (payload: boolean) => (dispatch: AppDispatch) => {
    dispatch({ type: ModalActionTypes.HANDLE_MODAL_ACCOUNT_VERIFIED, payload });
  };

export const handleModalPurchaseSummary =
  (payload: boolean) => (dispatch: AppDispatch) => {
    dispatch({ type: ModalActionTypes.HANDLE_MODAL_PURCHASE_SUMMARY, payload });
  };

export const handleModalPurchaseSuccess =
  (payload: boolean) => (dispatch: AppDispatch) => {
    dispatch({ type: ModalActionTypes.HANDLE_MODAL_PURCHASE_SUCCESS, payload });
  };

export const handleModalPurchaseError =
  (payload: boolean) => (dispatch: AppDispatch) => {
    dispatch({ type: ModalActionTypes.HANDLE_MODAL_PURCHASE_ERROR, payload });
  };
